<template>
  <div class="mc-image-link" v-if="data.images.length > 0">
    <router-link class="mc-image-link__link" :to="data.images[0].url">
      <img class="mc-image-link__image" :src="data.images[0].src" width="360" height="360" alt="">
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'BannerBlock',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {

    };
  },
  components: {

  }
}
</script>